import { Icon } from '@iconify/react';

import { Tooltip } from 'src/shared/components/ui';

// Function to get country name from country code
export const getCountryName = (code: string): string => {
  const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });

  return regionNames.of(code.toUpperCase()) || code;
};
// Simple component to display a country flag with its code
export const CountryFlag = ({
  countryCode,
  includeTooltip = true
}: {
  countryCode: string;
  includeTooltip?: boolean;
}) => {
  // Convert the country code to lowercase for the icon
  const countryLower = countryCode?.toLowerCase();

  const flagIcon = (
    <Icon icon={`flag:${countryLower}-4x3`} className="size-5" />
  );

  return (
    <div className="flex items-center gap-1">
      {countryLower &&
        (includeTooltip ? (
          <Tooltip
            className="rounded-lg shadow-md font-medium text-base"
            content={getCountryName(countryCode!)}
          >
            {flagIcon}
          </Tooltip>
        ) : (
          flagIcon
        ))}
    </div>
  );
};
